export const isRunningInIframe = () => {
  return window.location !== window.parent.location;
};

export const getWindow = () => {
  return isRunningInIframe() ? window.parent : window;
};

export const getCurrentPath = () => {
  return getWindow().location.pathname;
};

export const navigateTo = (url?: URL | string | null) => {
  getWindow().history.pushState({}, "", url);
  getWindow().location.reload();
};

export const navigateToPath = (url?: string) => {
  if (url) {
    getWindow().location.href = url;
  }
};

export const openSameTab = (url?: URL | string) => {
  if (!url) return;
  getWindow().location.href = url.toString();
};

export const openNewTab = (url?: URL | string) => {
  if (!url) return;
  getWindow().open(url, "_blank");
};

export const reloadWindow = () => {
  getWindow().location.reload();
};

export const getUrl = () => {
  const win = getWindow();
  if (win.location.hash) {
    return getUrlWithoutParams() + win.location.search + win.location.hash;
  }
  return getUrlWithoutParams() + win.location.search;
};

export const getUrlWithoutParams = () => {
  const win = getWindow();
  return win.location.origin + win.location.pathname;
};

export const isUrlEqualsToCurrentUrl = (url: string) => {
  return stripPreviewQueryParams(getUrl()) === stripPreviewQueryParams(url);
};

export const stripPreviewQueryParams = (url: string) => {
  if (!url || url === "") return url;
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.delete("pyne-guide-id");
    const result = urlObj.toString();
    return result;
  } catch (e) {
    console.error("Error parsing URL:", e);
    return url;
  }
};

export const openNewWindow = (url: string, width?: number, height?: number) => {
  var windowName = "pyneWindow" + Date.now();

  const windowWidth = window.screen.width;
  const windowHeight = window.screen.height;

  const popupWidth = width || windowWidth * 0.5;
  const popupHeight = height || windowHeight * 0.8;

  const left = windowWidth - popupWidth - 10;
  const top = (windowHeight - popupHeight) / 2;

  const features = `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=${popupWidth}, height=${popupHeight}, top=${top}, left=${left}`;

  getWindow().open(url, windowName, features);
};
